<ng-container *ngIf="info">
  <div>
    {{ 'sendInfo.via' | translate }} <span class="bold">{{ correspondenceTypeKey | translate }}</span>
    {{ 'sendInfo.sentBy' | translate }}<ng-container *ngIf="info.sentBy"
      >: <span class="bold" *ngIf="senderIsUserId; else rawSender">{{ info.sentBy | username | async }}</span>
      <ng-template #rawSender
        ><span class="bold">{{ info.sentBy }}</span></ng-template
      ></ng-container
    >
  </div>

  <div *ngFor="let recipient of recipients" class="recipient">
    <span *ngFor="let line of recipientLines(recipient); let first = first">
      <ng-container *ngIf="first">{{ 'sendInfo.recipient' | translate }}: </ng-container>
      <span class="bold wrap">{{ line }}</span>
      <br />
    </span>
  </div>

  <div *ngIf="sentAtDate as sentAt">
    {{ 'sendInfo.sentAt' | translate }}:
    <span class="bold"
      >{{ sentAt | date: 'EEEE, d. MMMM yyyy' }}, {{ sentAt | date: 'HH:mm' }}
      {{ 'timeSuffix' | translate }}</span
    >
  </div>
</ng-container>
